module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction: Sharing Sacred Places—A Mediterranean Tradition")]), _vm._v(" / "), _c('em', [_vm._v("Maria Couroucli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("Identification and Identity Formations around Shared Shrines in West Bank Palestine and Western Macedonia")])]), _vm._v(" / "), _c('em', [_vm._v("Glenn Bowman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("The "), _c('em', [_vm._v("Vakëf:")]), _vm._v(" Sharing Religious Space in Albania")])]), _vm._v(" / "), _c('em', [_vm._v("Gilles de Rapper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "spacef"
  }, [_c('em', [_vm._v("Komšiluk")]), _vm._v(" and Taking Care of the Neighbor’s Shrine in Bosnia-Herzegovina")])]), _vm._v(" / "), _c('em', [_vm._v("Bojan Baskar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("The Mount of the Cross: Sharing and Contesting Barriers on a Balkan Pilgrimage Site")])]), _vm._v(" / "), _c('em', [_vm._v("Galia Valtchinova")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("Muslim Devotional Practices in Christian Shrines: The Case of Istanbul")])]), _vm._v(" / "), _c('em', [_vm._v("Dionigi Albera and Benoît Fliche")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("Saint George the Anatolian: Master of Frontiers")])]), _vm._v(" / "), _c('em', [_vm._v("Maria Couroucli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("A Jewish-Muslim Shrine in North Morocco: Echoes of an Ambiguous Past")])]), _vm._v(" / "), _c('em', [_vm._v("Henk Driessen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("What Do Egypt’s Copts and Muslims Share? The Issue of Shrines")])]), _vm._v(" / "), _c('em', [_vm._v("Catherine Mayeur-Jaouen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("Apparitions of the Virgin in Egypt: Improving Relations between Copts and Muslims?")])]), _vm._v(" / "), _c('em', [_vm._v("Sandrine Keriakos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "spacef"
  }, [_vm._v("Sharing the "), _c('em', [_vm._v("Baraka")]), _vm._v(" of the Saints: Pluridenominational Visits to the Christian Monasteries in Syria")])]), _vm._v(" / "), _c('em', [_vm._v("Anna Poujeau")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#cro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Crossing the Frontiers between the Monotheistic Religions, an Anthropological Approach")]), _vm._v(" / "), _c('em', [_vm._v("Dionigi Albera")])]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/references#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0